import "@/index.css";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "./contexts/AuthContext";
import { ProtectedRoute } from "./components/ProtectedRoute";
import LoginPage from "./pages/LoginPage";
import RegisterPage from "./pages/RegisterPage";
import DashboardPage from "./pages/DashboardPage";
import DocumentsPage from "./pages/DocumentsPage";
import BlogPage from "./pages/BlogPage";
import AdminPage from "./pages/AdminPage";
import DirectoryPage from "./pages/DirectoryPage";
import QuickAnnouncePage from "./pages/QuickAnnouncePage";
import OverviewsPage from "./pages/OverviewsPage";
import VacationPage from "./pages/VacationPage";
import UdrzbaPage from "./pages/UdrzbaPage";
import ITServisPage from "./pages/ITServisPage";
import ITRequestsPage from "./pages/ITRequestsPage";
import AnalyticsK2Page from "./pages/AnalyticsK2Page";
import AnalyticsHubPage from "./pages/AnalyticsHubPage";
import AnalyticsDetailPage from "./pages/AnalyticsDetailPage";
import { Toaster } from "./components/ui/sonner";

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          {/* Public Routes */}
          <Route path="/login" element={<LoginPage />} />
          <Route path="/register" element={<RegisterPage />} />
          <Route path="/upozorneni" element={<QuickAnnouncePage />} />
          
          {/* Protected Routes */}
          <Route path="/" element={
            <ProtectedRoute>
              <DashboardPage />
            </ProtectedRoute>
          } />
          
          <Route path="/documents" element={
            <ProtectedRoute>
              <DocumentsPage />
            </ProtectedRoute>
          } />
          
          <Route path="/directory" element={
            <ProtectedRoute>
              <DirectoryPage />
            </ProtectedRoute>
          } />
          
          <Route path="/blog" element={
            <ProtectedRoute>
              <BlogPage />
            </ProtectedRoute>
          } />
          
          <Route path="/blog/:postId" element={
            <ProtectedRoute>
              <BlogPage />
            </ProtectedRoute>
          } />
          
          <Route path="/prehledy" element={
            <ProtectedRoute>
              <OverviewsPage />
            </ProtectedRoute>
          } />

          <Route path="/analytika" element={
            <ProtectedRoute>
              <AnalyticsHubPage />
            </ProtectedRoute>
          } />

          <Route path="/analytika/vydeje-nes" element={
            <ProtectedRoute>
              <AnalyticsK2Page />
            </ProtectedRoute>
          } />

          <Route path="/analytika/:id" element={
            <ProtectedRoute>
              <AnalyticsDetailPage />
            </ProtectedRoute>
          } />

          <Route path="/analytika-k2" element={<Navigate to="/analytika/vydeje-nes" replace />} />
          
          <Route path="/dovolena" element={
            <ProtectedRoute>
              <VacationPage />
            </ProtectedRoute>
          } />

          <Route path="/udrzba" element={
            <ProtectedRoute>
              <UdrzbaPage />
            </ProtectedRoute>
          } />

          <Route path="/it/pozadavek-servis" element={
            <ProtectedRoute>
              <ITServisPage />
            </ProtectedRoute>
          } />

          <Route path="/it/pozadavky" element={
            <ProtectedRoute>
              <ITRequestsPage />
            </ProtectedRoute>
          } />
          
          {/* Admin Only Routes */}
          <Route path="/admin" element={
            <ProtectedRoute adminOnly>
              <AdminPage />
            </ProtectedRoute>
          } />
          
          {/* Fallback */}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" richColors />
    </AuthProvider>
  );
}

export default App;
